<template>
  <div v-if="facilitatorInstructions">
    <span v-html="facilitatorInstructions"/>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  data: function() {
    return {
    };
  },
  components: {
  },
  created() {
  },
  computed: {
    isGameOn() {
      // Show question only if we are on a game page
      if (this.$store.getters.getIsClassic) {
          return (
          !this.reportingPage &&
          this.$store.getters.getCurrentCaseNumber > 0 &&
          this.$store.getters.getCurrentCaseNumber <=
            this.$store.getters.getNumberOfCases
        );
      } else {
          return (
          !this.reportingPage &&
          this.$store.getters.getCurrentCaseNumber > 0 &&
          this.$store.getters.getCurrentCaseNumber <=
            this.$store.getters.getNumberOfRPSCases
        );       
      }
    },
    welcomePage() {
      return this.$router.currentRoute.name === "PlayerWelcome";
    },
    reportingPage() {
      return this.$router.currentRoute.name.startsWith("reporting") || this.$router.currentRoute.name.startsWith("RpsReporting");
    },
    askGameCodePage() {
      return this.$router.currentRoute.name === "gamecode" || this.$router.currentRoute.name === "home";
    },
    selfEvaluationPage() {
      return this.$router.currentRoute.name === "SelfEvaluation";
    },
    lastPage() {
      return this.$router.currentRoute.name === "LastPage";
    },
    beginPage() {
      return this.$router.currentRoute.name === "FirstPage";
    },
    rpsLastPage() {
      return this.$router.currentRoute.name === "RpsLastPage";
    },
    rpsBeginPage() {
      return this.$router.currentRoute.name === "RpsFirstPage";
    },
    getThisCase() {
      return this.$store.getters.getCaseByCaseNumber(
        this.$store.getters.getCurrentCaseNumber
      );
    },
    getThisRPSCase() {
      return this.$store.getters.getRPSCaseByCaseNumber(
        this.$store.getters.getCurrentCaseNumber
      );
    },    
    facilitatorInstructions() {
      if (this.$store.getters.getIsClassic) {
        const scenario = this.$store.getters.getScenarioInCurrentLocale;
        let fallbackScenario = this.$store.getters.getScenarioInSomeLocale("en"); // Fallback
        if (!fallbackScenario) {
          // In case there's no English scenario, there will be Finnish
          fallbackScenario = this.$store.getters.getScenarioInSomeLocale("fi");
        }

        let fallbackCase = this.$store.getters.getCaseByCaseNumberAndLocale(this.$store.getters.getCurrentCaseNumber, "en");
        if (!fallbackCase) {
          fallbackCase = this.$store.getters.getCaseByCaseNumberAndLocale(this.$store.getters.getCurrentCaseNumber, "fi");
        }

        if (this.reportingPage) {
          return scenario.reporting_facilitator_instructions ? scenario.reporting_facilitator_instructions : fallbackScenario.reporting_facilitator_instructions;
        }

        if (this.selfEvaluationPage) {
          return scenario.self_evaluation_facilitator_instructions ? scenario.self_evaluation_facilitator_instructions : fallbackScenario.self_evaluation_facilitator_instructions;
        }

        if (this.beginPage) {
          return scenario.begin_page_facilitator_instructions ? scenario.begin_page_facilitator_instructions : fallbackScenario.begin_page_facilitator_instructions;
        }

        if (this.lastPage) {
          return scenario.last_page_facilitator_instructions ? scenario.last_page_facilitator_instructions : fallbackScenario.last_page_facilitator_instructions;
        }

        if (this.isGameOn) {
          return this.getThisCase.facilitatorInstructions ? this.getThisCase.facilitatorInstructions : fallbackCase.facilitatorInstructions;
        } else {
          return null;
        }
      } else {
        // RPS
        const rpsScenario = this.$store.getters.getRPSScenarioInCurrentLocale;
        let fallbackRPSScenario = this.$store.getters.getRPSScenarioInSomeLocale("en"); // Fallback

        let fallbackRPSCase = this.$store.getters.getRPSCaseByCaseNumberAndLocale(this.$store.getters.getCurrentCaseNumber, "en");
        if (!fallbackRPSCase) {
          fallbackRPSCase = this.$store.getters.getRPSCaseByCaseNumberAndLocale(this.$store.getters.getCurrentCaseNumber, "fi");
        }

        if (!fallbackRPSScenario) {
          // In case there's no English scenario, there will be Finnish
          fallbackRPSScenario = this.$store.getters.getRPSScenarioInSomeLocale("fi");
        }       
        
        if (this.rpsBeginPage) {
          return rpsScenario.begin_page_facilitator_instructions ? rpsScenario.begin_page_facilitator_instructions : fallbackRPSScenario.begin_page_facilitator_instructions;
        }

        if (this.rpsLastPage) {
          return rpsScenario.last_page_facilitator_instructions ? rpsScenario.last_page_facilitator_instructions : fallbackRPSScenario.last_page_facilitator_instructions;
        }

        if (this.reportingPage) {
          return rpsScenario.reporting_facilitator_instructions ? rpsScenario.reporting_facilitator_instructions : fallbackRPSScenario.reporting_facilitator_instructions;
        }        

        if (this.isGameOn) {
          return this.getThisRPSCase.facilitatorInstructions ? this.getThisRPSCase.facilitatorInstructions : fallbackRPSCase.facilitatorInstructions;
        } else {
          return null;
        }
      }
    },
  },
  methods: {
  }
};
</script>
